/**
 * TV Channel Video Configuration
 * Phase D2.2: Simulated IPTV with looping video per channel
 *
 * Using royalty-free demo videos for each channel type.
 * In production, these would be replaced with actual IPTV streams.
 *
 * Sources used (all verified HTTP 200, all small enough for instant autoplay):
 *   - interactive-examples.mdn.mozilla.net/media/cc0-videos/ — CC0 licensed, ~0.5–1MB
 *   - www.w3schools.com/html/ — W3Schools tutorial samples, ~300–800KB
 *   - media.w3.org/2010/05/ — W3C spec test media, ~2–5MB
 */

// Channel ID to video URL mapping
export const channelVideoMap: Record<string, string> = {
  // HBO - Cinematic/Drama feel (~1.1MB, CC0, fast autoplay)
  ch_hbo: 'https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4',

  // CNN - News/Documentary (~515KB, CC0, fast autoplay)
  ch_cnn: 'https://interactive-examples.mdn.mozilla.net/media/cc0-videos/friday.mp4',

  // BBC - Nature/Documentary (~788KB)
  ch_bbc: 'https://www.w3schools.com/html/mov_bbb.mp4',

  // ESPN - Sports action (~318KB)
  ch_espn: 'https://www.w3schools.com/html/movie.mp4',

  // Discovery - Science/Adventure (~4.4MB)
  ch_discovery: 'https://media.w3.org/2010/05/sintel/trailer.mp4',

  // Streaming - Tech/Modern (~2.8MB)
  ch_streaming: 'https://media.w3.org/2010/05/video/movie_300.mp4',
};

// Fallback video if channel not found
export const fallbackVideo = 'https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4';

/**
 * Get video URL for a channel ID
 */
export function getChannelVideoUrl(channelId: string): string {
  return channelVideoMap[channelId] || fallbackVideo;
}
